import { useState } from 'react';

export const useToggle = (initialState?: boolean) => {
  const [state, setState] = useState(initialState ?? false);

  const toggle = () => {
    setState((prev) => !prev);
  };

  return [state, toggle] as [boolean, () => void];
};
